import styled from 'styled-components';
import { H1 } from '@finect/tabular-core/Headings';
import { EditorContainer } from '@finect/tabular-draft-editor';
import { Tags } from '../Tags';

/* eslint-disable */
/* stylelint-disable */
export const QuestionTitle = styled.div`
  position: relative;
  max-width: 791px;

  & + ${/* sc-sel */ EditorContainer}, & + p {
    margin-top: 21px;
  }

  & + ${/* sc-sel */ EditorContainer}[hidden] + ${/* sc-sel */ Tags} {
    margin-top: 9px;
  }
`;
/* stylelint-enable */

export const TitleInput = styled(H1)`
  width: 100%;

  &.insert {
    padding: 5px;
    border: 1px solid #d5d5d6;
    border-radius: 4px;
    background-color: #fdfdfd;
  }
`;
/* eslint-enable */
